import React from 'react';

import { Modal as BootstrapModal } from 'react-bootstrap';
import { ModalContext } from './ModalContext';

interface IModalBodyProps {
    className?: string;
}

export const ModalBody = ({children, className}: React.PropsWithChildren<IModalBodyProps>) => {
    const {variant} = React.useContext(ModalContext);

    const classNameComputed = `Modal__body ${className || ''} ${variant ? `Modal__body--${variant}` : ''}`;

    return (
        <BootstrapModal.Body className={classNameComputed}>{children}</BootstrapModal.Body>
    );
};
